import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { ThemeConfiguration } from "../shared/config/theme.config";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  public themeConfig: ThemeConfiguration;
  private domain: string;

  constructor(private http: HttpClient, private title: Title, public translate: TranslateService) {  }

  public configTheme() {
    this.domain = window.location.hostname
      .replace('http://', '')
      .replace('https://', '')
      .replace('www.', '')
      .replace('.com', '')
      .replace('.co', '')
      .replace('.co.in', '')
      .replace('.in', '');
    if (!sessionStorage.getItem(this.domain) && !this.themeConfig) {
      this.prepareTheme(this.domain);
    }
    else {
      this.themeConfig = JSON.parse(sessionStorage.getItem(this.domain));
      this.applyTheme(this.themeConfig);
      this.prepareTheme(this.domain);
    }
  }
  private prepareTheme(domainToUse: string) {
    this.http.get<ThemeConfiguration>(`assets/config/${domainToUse}.json`)
      .subscribe(
        (data: ThemeConfiguration) => {
          if (data) { sessionStorage.setItem(this.domain, JSON.stringify(data)); this.applyTheme(data); }
        },
        (error: HttpErrorResponse) => { },
        () => {
          if (!this.themeConfig) {
            if (domainToUse != environment.defaultDomain) {
              this.prepareTheme(environment.defaultDomain);
            } else {
              this.applyTheme(defaultTheme);
            }
          }
        });
  }

  private applyTheme(themeConfig: ThemeConfiguration) {
    this.title.setTitle(themeConfig.Title);
    document.documentElement.style.setProperty('--primary-color', themeConfig.Theme.PrimaryColor);
    document.documentElement.style.setProperty('--secondary-color', themeConfig.Theme.SecondaryColor);
    document.documentElement.style.setProperty('--midtheme-color', themeConfig.Theme.MidThemeColor);
    document.documentElement.style.setProperty('--lowtheme-color', themeConfig.Theme.LowThemeColor);
    document.documentElement.style.setProperty('--dimtheme-color', themeConfig.Theme.DimThemeColor);
    document.documentElement.style.setProperty('--tdheadertheme-color', themeConfig.Theme.TDHeaderThemeColor);
    document.documentElement.style.setProperty('--itembordertheme-color', themeConfig.Theme.ItemBorderThemeColor);
    document.documentElement.style.setProperty('--progressbartheme-color', themeConfig.Theme.ProgressBarThemeColor);
    document.documentElement.style.setProperty('--logobacktheme-color', themeConfig.Theme.LogoBackThemeColor);
    document.documentElement.style.setProperty('--tdincompleteIcontheme-Color', themeConfig.Theme.TDIncompleteIconColor);
    document.documentElement.style.setProperty('--gradient1theme-Color', themeConfig.Theme.gradient1);
    document.documentElement.style.setProperty('--gradient2theme-Color', themeConfig.Theme.gradient2);
    document.documentElement.style.setProperty('--gradient3theme-Color', themeConfig.Theme.gradient3);
    document.documentElement.style.setProperty('--ProgressBar-TextColor', themeConfig.Theme.ProgressBarTextColor);
    document.documentElement.style.setProperty('--ProgressBar-FillColor', themeConfig.Theme.ProgressBarFillColor);
    this.themeConfig = themeConfig;
  }
}

export const defaultTheme: ThemeConfiguration = {
  Title: "Headless Assessment System",
  Heading: "Create, update, and publish your tests dynamically across any digital platform or channel.",
  SubHeading: "",
  TagLine: "",
  Description: "SimpliAssess is an online test maker that brings high quality assessments within everyone's reach. It's an easy-to-use headless assessment platform for educators, course administrators and training professionals to conduct online tests and quizzes across multiple channels.",
  DescSpanish: "",
  DescPortugese: "",
  LogoUrl: "assets/logo/logo.png",
  ImgUrl: "",
  svaslogoUrl: "",
  width: "",
  TestDeliveryUrl: "",
  videoURL: "assets/video/test-delivery.mp4",
  enableVideo: "",
  Theme: {
    FontFamily: "Poppins",
    PrimaryColor: "#3F51B5",
    SecondaryColor: "#25C2A3",
    MidThemeColor: "#EA4335",
    LowThemeColor: "#e37f1e",
    DimThemeColor: "#e37f1e",
    TDHeaderThemeColor: "#fff",
    ItemBorderThemeColor : "lightGray",
    ProgressBarThemeColor: "gray",
    LogoBackThemeColor: "#3F51B5",
    TDIncompleteIconColor: "#3F51B5",
    gradient1: "",
    gradient2: "",
    gradient3: "",
    ProgressBarTextColor: "",
    ProgressBarFillColor: "",
  }
}


